import { useMutation } from '@tanstack/react-query';
import { workPlanUpdate } from 'services/reactQueryservices';

const useWorkPlanUpdate = () => {
    const { mutate, error, isSuccess, isError, isLoading } = useMutation({
        mutationFn: workPlanUpdate,
        onSettled: (data, error) => { }
    });
    return {
        mutate,
        error,
        isSuccess,
        isError,
        isLoading
    };
}

export default useWorkPlanUpdate